import { useId } from 'react';
import { getFeatureAvailability } from './featureAvailability';
import styles from './FeatureAction.module.css';

export default function FeatureAction({
  feature, action, children, onClick, disabled = false, reason,
  type = 'button', className, 'aria-describedby': describedBy, ...props
}) {
  const reasonId = useId();
  const availability = getFeatureAvailability(feature);
  const allowed = availability.can(action);
  const description = [describedBy, !allowed ? reasonId : null].filter(Boolean).join(' ') || undefined;
  return <span className={styles.wrapper}>
    <button {...props} type={type} className={className}
      disabled={disabled || !allowed} aria-describedby={description}
      onClick={event => {
        if (disabled || !getFeatureAvailability(feature).can(action)) return;
        onClick?.(event);
      }}>{children}</button>
    {!allowed && <small id={reasonId} className={styles.reason}>
      {reason || 'This action is not available in this release.'}
    </small>}
  </span>;
}